import type { Sharing as SharingType, SharingOptions } from "./types";

const isShareSupported = (): boolean =>
  typeof navigator !== "undefined" && typeof navigator.share === "function";

const Sharing: SharingType = {
  isAvailable: () => isShareSupported(),
  share: async (options: SharingOptions) => {
    if (!isShareSupported()) {
      throw new Error("Web Share API is not supported in this browser");
    }
    await navigator.share({
      title: options.title,
      url: options.url,
    });
  },
};

export default Sharing;
